import type { ComponentProps } from 'react';
import { useV3Redesign } from '~/helper/useV3Redesign';
import { VisitBookingWidget } from './VisitBookingWidget';
import { LegacyVisitBookingWidget } from './LegacyVisitBookingWidget';

export function VisitBookingWidgetGate(
  props: ComponentProps<typeof VisitBookingWidget>,
) {
  return useV3Redesign() ? (
    <VisitBookingWidget {...props} />
  ) : (
    <LegacyVisitBookingWidget {...props} />
  );
}
